module.exports = __webpack_public_path__ + "img/course-cover01.361cc658.png";